import { http, setFormData } from '@/utils/http'
import { LOCATION_FETCH, LOCATION_CREATE, LOCATION_UPDATE } from '@/store/actions/location'

const state = {
  locations: []
}

const getters = {
  locations: (state, g, rS, rootGetters) => {
    const locations = state.locations.map(location => {
      location.state = rootGetters.stateName(location.state_id)
      return location
    })
    return locations
  },
  locationsAsOptions: state => (stateId) => {
    let activeLocationsInState = state.locations.filter(location => {
      return location.status === 'active' && location.state_id === stateId
    })
    activeLocationsInState = activeLocationsInState.sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })
    return activeLocationsInState.map(
      location => ({ text: location.name, value: location._id })
    )
  },
  locationField: state => (field = 'name', id) => { // get location [field] by id
    const location = state.locations.find(location => location._id === id)
    return location !== undefined ? location[field] : ''
  },
  locationsByField: state => (field, value) => state.locations.filter(location => location[field] === value)
}

const mutations = {
  [LOCATION_FETCH]: (state, payload) => {
    state.locations = [ ...payload ]
  },
  [LOCATION_UPDATE]: (state, payload) => {
    const updatedLocations = state.locations.map(
      location => (location._id === payload._id ? Object.assign(location, payload) : location)
    )
    state.locations = updatedLocations
  }
}

const actions = {
  [LOCATION_FETCH]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      http.get('location/read_all')
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(LOCATION_FETCH, response.data)
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [LOCATION_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('location/create', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [LOCATION_UPDATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('location/update', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(LOCATION_UPDATE, payload)
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
